export default __webpack_public_path__ + "static/ctaModule_cloud_bottom_desktop-cdac79facaead6839e4b1703da33335f.webp";